// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iframe-container[data-v-083f8a34]{width:100%;height:100%;display:flex;flex-direction:column}#myIframe[data-v-083f8a34]{flex:1;width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
